import type { User } from "src/types/user";

const getInitials = (name = ""): string => {
    return name
        .replace(/\s+/, " ")
        .split(" ")
        .slice(0, 2)
        .map((v) => v && v[0].toUpperCase())
        .join("");
};

export const getInitialUser = (user: User): string => {
    let initFirstName = "";
    let initLastName = "";
    if (user.lastName && user.lastName.length > 0) {
        initLastName = user.lastName.substring(0, 1).toUpperCase();
    }

    if (user.firstName && user.firstName.length > 0) {
        initFirstName = user.firstName.substring(0, 1).toUpperCase();
    }

    return initFirstName + initLastName;
};

export default getInitials;
